import React from 'react';

const AIGramshala = () => {
  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <div className="bg-white border-2 border-gray-200 rounded-lg p-8 md:p-12 hover:border-crimson transition-all duration-300 shadow-sm">
            <div className="flex items-start gap-4 mb-6">
              <div className="w-16 h-16 bg-crimson rounded-lg flex items-center justify-center flex-shrink-0">
                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
                </svg>
              </div>
              <div>
                <p className="text-crimson font-outfit font-600 text-sm uppercase tracking-wide mb-2">
                  Related Initiative
                </p>
                <h3 className="text-2xl md:text-3xl font-outfit font-800 text-black mb-4">
                  AI Gramshala
                </h3>
                <p className="text-lg font-outfit font-600 text-gray-700 mb-6">
                  Hands-on AI learning workshops for schools & rural communities
                </p>
                <a 
                  href="https://gramshala.aianytime.net/" 
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-secondary inline-block"
                >
                  Learn More
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AIGramshala;
